import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import merchant_services from "services/merchant_services";
import {
  networkTypeSelector,
  treasuryIdSelector,
} from "store/userSliceHelpers";
import type { MerchantApiRecord } from "utils/AxiosUtil";

export function useMerchants() {
  const { user } = useAuth();
  const treasuryId = useSelector(treasuryIdSelector);
  const networkType = useSelector(networkTypeSelector);
  return useQuery<MerchantApiRecord[]>({
    // treasuryId is in the key because the queryFn reads it — the list is per-treasury, the same
    // way ["merchantsCount", treasuryId] and ["redeemRequests", treasuryId, token] are.
    queryKey: ["merchants", treasuryId],
    queryFn: () => merchant_services.fetchMerchants(treasuryId!, networkType),
    enabled: !!user && !!treasuryId,
  });
}
